class FeaturedVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const play = this.querySelector('.js-featured-video-play');
    const player = this.querySelector('.js-featured-video-player');
    const close = this.querySelector('.js-featured-video-close');

    if (play && player) {
      play.addEventListener('click', () => {
        this.classList.add('featured-video-active');
        player.play();
      });
    }

    if (close) {
      close.addEventListener('click', () => {
        this.classList.remove('featured-video-active');
        player.pause();
      });
    }
  }
}

if (!customElements.get('featured-video')) {
  customElements.define('featured-video', FeaturedVideo);
}
